export enum CatalogAPIStatus {
  UNKNOWN,
  FETCHING,
  FETCHED,
  FAILED,
  FAILED_401
}
